module.exports = __webpack_public_path__ + "img/map_genova.fbb3f413.png";